import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { AccordionWithArrow, MuiTextField, MuiButton, Message, LoaderDots } from '../../../../components'
import userManagement from '../../../../services/userManagement.service'
// import { CONST_PASSWORD_USER_MANAGEMENT } from '../../../../constants'
import { useGlobalStore } from '../../../../store'
import { validateLocalPassword, consoleLog, isValidRespID } from '../../../../util'
import { OuterWrapper } from './style'

const Add = () => {
  const { company } = useGlobalStore()

  return (
    <AccordionWithArrow title={`Associate user to ${(company?.WebName || company?.DisplayName)}`} accordionstyle='fieldset'>
      <AddRow type={ { name: 'Analyst', value: 0 } } />
      <AddRow type={ { name: 'Strategist', value: 1 } } />
    </AccordionWithArrow>
  )
}

const AddRow = ({ type }) => {
  const { company } = useGlobalStore()
  const initialFormObj = {
    emailAddress: '',
    userType: type.name,
    passCode: ''
  }

  const form = useRef()
  // const [formSectionData, setFormSectionData] = useState(defaultDataFunc())
  const [loader, setLoader] = useState(false)
  const [formData, setFormData] = useState(initialFormObj)
  const [respDataMessage, setRespDataMessage] = useState({})

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      userType: formData?.userType?.trim() || '',
      emailAddress: formData?.emailAddress?.trim() || '',
      passCode: formData?.passCode?.trim() || ''
    }

    if (obj.userType === '' || obj.emailAddress === '' || obj.passCode === '') {
      setRespDataMessage({ type: 'error', msg: 'All fields are mandatory !!' })
      return false
    // } else if (obj.passCode !== CONST_PASSWORD_USER_MANAGEMENT) {
    } else if (!validateLocalPassword(obj.passCode, 'userManagement')) {
      setRespDataMessage({ type: 'error', msg: 'Incorrect Passcode' })
      return false
    }

    setLoader(true)
    const payload = { emailAddress: obj.emailAddress, userTypeId: 1 }
    userManagement.getUserApi(payload)
      .then(resp => {
        if (resp?.EmailAddress) {
          // setRespDataMessage({ type: 'error', msg: 'A user with this email address already exists in the system. Please Sign In to access your account.' })
          // setLoader(false)
        // } else if (resp) {
          const payload = { organizationId: company?.OrganizationId, emailAddress: obj.emailAddress, adminUserType: (obj.userType === 'Analyst') ? 0 : 1 }
          userManagement.setOrganizationAdminUserApi(payload)
            .then(resp => {
              if (isValidRespID(resp)) {
                setRespDataMessage({ type: 'success', msg: 'Done!' })
              } else {
                setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(resp)}` })
              }
            })
            .catch(error => {
              setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(error)}` })
              consoleLog('ERROR : ', error)
            })
            .finally(() => {
              setLoader(false)
            })

          // setRespDataMessage({ type: 'success', msg: 'Done!' })
          resetForm()
        } else if (resp) {
          setRespDataMessage({ type: 'error', msg: 'Invalid email address!!' })
          setLoader(false)
        } else {
          setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(resp)}` })
          setLoader(false)
        }
      })
      .catch(error => {
        setRespDataMessage({ type: 'error', msg: `Operation Failed. ${JSON.stringify(error)}` })
        setLoader(false)
      })
  }

  const resetForm = () => {
    setFormData(initialFormObj)
    // setRespDataMessage({ type: 'success', msg: '' })
  }

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='off'>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <MuiTextField
              name='emailAddress'
              placeholder='Enter your Email'
              label='Your Email'
              onChange={(e) => onChangeHandler('emailAddress', e.target.value)}
              variant='standard'
              value={formData?.emailAddress || ''}
              inputProps={{ autocomplete: 'one-time-code', ariaAutocomplete: 'both', ariaHaspopup: 'false', autocapitalize: 'off', autocorrect: 'off', maxlength: 50 }}
              // inputProps={{ maxlength: 25 }}
            />
          </Grid>
          <Grid item xs={3} style={{ display: 'none' }}>
            <MuiTextField
              name='userType'
              placeholder='Enter User Type'
              label='User Type'
              onChange={(e) => onChangeHandler('userType', e.target.value)}
              variant='standard'
              value={formData?.userType || ''}
              disabled={true}
              className='userType'
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='passCode'
              placeholder='Enter Pass Code'
              label='Pass Code'
              onChange={(e) => onChangeHandler('passCode', e.target.value)}
              variant='standard'
              value={formData?.passCode || ''}
              inputProps={{ autocomplete: 'one-time-code', ariaAutocomplete: 'both', ariaHaspopup: 'false', autocapitalize: 'off', autocorrect: 'off' }}
              type='password'
            />
          </Grid>
          <Grid item xs={3}>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ marginTop: '10px', minWidth: '160px' }}
                disabled={loader}
              >
                Add as {type.name}
              </MuiButton>
          </Grid>
          <Grid item xs={12} style={{ padding: '0 0 0 15px' }}>
            <Message type={respDataMessage?.type} align='left'>{respDataMessage?.msg || ''}</Message>
            {loader && <LoaderDots />}
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

AddRow.propTypes = {
  type: PropTypes.object
}

export default Add
